// 西班牙区域和对应的税法
export const SPAIN_CITY_AREA = [
    {
        value: 'SPAIN_OTHER',
        label: 'SPAIN_OTHER(Verifactu)'
    },
    {
        value: 'CANARY_ISLANDS',
        label: 'CANARY_ISLANDS(Verifactu)'
    },
    {
        value: 'CEUTA',
        label: 'CEUTA(Verifactu)'
    },
    {
        value: 'MELILLA',
        label: 'MELILLA(Verifactu)'
    },
    {
        value: 'ARABA',
        label: 'ARABA(TicketBAI)'
    },
    {
        value: 'BIZKAIA',
        label: 'BIZKAIA(TicketBAI)'
    },
    {
        value: 'GIPUZKOA',
        label: 'GIPUZKOA(TicketBAI)'
    },
    {
        value: 'Na_Ticket',
        label: 'Na_Ticket'
    }
];

// 西班牙Verifactu
export const SPAIN_VERIFACTU_AREAS = ['SPAIN_OTHER', 'CANARY_ISLANDS', 'CEUTA', 'MELILLA'];

// 西班牙TicketBAI
export const SPAIN_TICKETBAI_AREAS = ['ARABA', 'BIZKAIA', 'GIPUZKOA'];

// 当前区域属于Verifactu
export function isVerifactuArea(area: string): boolean {
    return SPAIN_VERIFACTU_AREAS.includes(area);
}
// 当前区域属于TicketBAI
export function isTicketBAIArea(area: string): boolean {
    return SPAIN_TICKETBAI_AREAS.includes(area);
}

// 根据不同地区显示不同地区注册地址
export const getRegisterUrl = (name: string) => {
    const links = {
        ARABA: 'https://web.araba.eus/es/hacienda/ticketbai/registro-certificados-dispositivo',
        BIZKAIA: 'https://ataria.ebizkaia.eus/es/catalogo-de-tramites-y-servicios?procID=1740',
        GIPUZKOA: 'https://zergabidea.gipuzkoa.eus/WAS/HACI/HGFZergaBideaWEB/info?locale=es_ES'
    }
    return links[name]
}